import { Component } from 'react';
import './FAQ.scss';

class SellerFAQFolderList extends Component {
    getArticleCountText = (folder) => {
        if (folder?.type === 'external-link') {
            return '';
        }

        const count = folder.articleCount || folder.article_count || folder.articles || folder.pageCount || folder.count;

        if (count === undefined || count === null || count === '') {
            return '';
        }

        return `${count} ${Number(count) === 1 ? 'article' : 'articles'}`;
    }

    getPageTitle = (page) => page?.title || page?.name || page?.displayName || page?.text || 'Untitled article';

    getFolderIconType = (folder) => {
        const title = String(folder?.title || '').toLowerCase();

        if (title.includes('location')) {
            return 'fas fa-map-marker-alt';
        }

        if (title.includes('user') || title.includes('team')) {
            return 'fas fa-users';
        }

        if (title.includes('item')) {
            return 'fas fa-shopping-cart';
        }

        if (title.includes('closing')) {
            return 'fas fa-handshake';
        }

        if (title.includes('invoicing')) {
            return 'fas fa-file-invoice-dollar';
        }

        if (title.includes('payment')) {
            return 'fas fa-credit-card';
        }

        if (title.includes('customer')) {
            return 'fas fa-user-cog';
        }

        if (title.includes('vendor') || title.includes('third party')) {
            return 'fas fa-building';
        }

        if (title.includes('other')) {
            return 'fas fa-question-circle';
        }

        return 'fas fa-info-circle';
    }

    renderHelpIcon = (folder) => (
        <div
            className="help-card-icon"
            aria-hidden="true"
            style={{ color: '#A50050', fontSize: '42px', marginBottom: '20px' }}
        >
            <i className={this.getFolderIconType(folder)} />
        </div>
    );

    renderFolders = () => {
        const { folders, onFolderClick } = this.props;

        return (
            <div className="help-center-shell">
                <h1>Welcome to the Seller Help Center</h1>
                <div className="help-card-grid">
                    {folders.map(folder => (
                        <button
                            type="button"
                            key={folder.id}
                            className="help-folder-card"
                            onClick={() => onFolderClick(folder)}
                        >
                            {this.renderHelpIcon(folder)}
                            <span className="help-folder-title">{folder.title}</span>
                            <span className="help-folder-count">{this.getArticleCountText(folder)}</span>
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    renderPages = () => {
        const { basePath, pages, pageError, selectedFolderTitle, onPageClick } = this.props;

        return (
            <div className="help-center-shell help-article-shell">
                <button
                    type="button"
                    className="help-back-link"
                    onClick={() => this.props.history.push(basePath)}
                >
                    <i className="fas fa-arrow-left"></i>
                </button>
                <h1 className="mb-5">{selectedFolderTitle}</h1>
                <div className="help-page-list">
                    {pages.length ? pages.map((page, index) => (
                        <button
                            type="button"
                            className="help-page-list-card"
                            key={page.id || page.contentId || index}
                            onClick={() => onPageClick(page)}
                        >
                            <div className="help-page-list-title">{this.getPageTitle(page)}</div>
                            <span className="help-page-list-icon" aria-hidden="true">
                                <i className="fas fa-chevron-right"></i>
                            </span>
                        </button>
                    )) :
                        <div className="help-empty-state">{pageError || 'No articles found for this folder.'}</div>
                    }
                </div>
            </div>
        );
    }

    render() {
        return this.props.folderId ? this.renderPages() : this.renderFolders();
    }
}

export default SellerFAQFolderList;
